import { render, staticRenderFns } from "./download2.vue?vue&type=template&id=6a3ee75a&scoped=true&"
import script from "./download2.vue?vue&type=script&lang=js&"
export * from "./download2.vue?vue&type=script&lang=js&"
import style0 from "./download2.vue?vue&type=style&index=0&id=6a3ee75a&prod&lang=scss&scoped=true&"
import style1 from "./download2.vue?vue&type=style&index=1&id=6a3ee75a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ee75a",
  null
  
)

export default component.exports